import { Tally1 } from 'lucide-react';
import React, { useState } from 'react'
import { Tooltip } from 'react-tooltip';

const SidebarCollapseButton = ({ s, collapsed, setCollapsed }) => {
    const [collapseHovered, setCollapseHovered] = useState(false);



    return (
        <>
            <Tooltip id="collapsebtn-tooltip" style={{ zIndex: 10 }} />
            <div
                data-tooltip-id="collapsebtn-tooltip"
                data-tooltip-content={collapsed ? "Expand" : "Collapse"}
                style={{
                    ...s.collapseBtn,
                    background: "transparent",
                    border: "none",
                    boxShadow: "none",
                }}
                onClick={() => setCollapsed((c) => !c)}
                onMouseEnter={() => setCollapseHovered(true)}
                onMouseLeave={() => setCollapseHovered(false)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        setCollapsed((c) => !c);
                    }
                }}
                title={collapsed ? "Expand" : "Collapse"}
            >
                <span
                    style={{
                        color: collapseHovered ? "#604FF8" : "#404D60",
                        transform:!collapsed ? "rotate(0deg)" : "rotate(180deg)",
                        display: "flex",
                        position: "relative",
                        width: 18,
                        height: 18,
                        margin: "0 auto",
                        left: !collapsed ? "3px" : "-5px",
                    }}
                >
                    <span
                        style={{
                            position: "absolute",
                            inset: 0,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            transform: collapseHovered
                                ? `translateX(${collapsed ? "1px" : "-1px"}) translateY(0px) rotate(${!collapsed ? "-45deg" : "-45deg"})`
                                : "translateY(0px) rotate(0deg)",
                            transition: "transform .22s ease",
                        }}
                    >
                        <Tally1 size={12} strokeWidth={2.2} />
                    </span>
                    <span
                        style={{
                            position: "absolute",
                            inset: 0,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            transform: collapseHovered
                                ? `translateX(${collapsed ? "1px" : "-1px"}) translateY(0px) rotate(${!collapsed ? "45deg" : "45deg"})`
                                : "translateY(0px) rotate(0deg)",
                            transition: "transform .22s ease",
                        }}
                    >
                        <Tally1 size={12} strokeWidth={2.2} />
                    </span>
                </span>
            </div>
        </>

    )
}

export default SidebarCollapseButton